<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Opportunity</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/opportunitys/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>



<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/Opportunitys/MenuList.vue";
import lang from "@/views/modules/Opportunitys/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/Opportunitys/ListView.vue";
import CustomSearch from "@/views/modules/Opportunitys/SearchView.vue";
export default {
name: "list-opportunity",
components: {
    breadcrumbs,
    GenericList,
    CustomList,
    CustomSearch,
    },
    data(){
        return{
            generic: true,
            isActive:false,
            metaList:[
                {
                    label: lang.LBL_OPPORTUNITY_TITLE,
                    link:true,
                    width:300,
                    moduleName:'Opportunitys',/// moduleName is required
                    routePath:'opportunitys',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'opportunity_title'
                },
                {
                    label: lang.LBL_OPPORTUNITY_YEAR,
                    link:false,
                    width:30,
                    routePath:'Opportunitys',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'opportunity_year'
                },
                {
                    label: lang.LBL_OPPORTUNITY_TYPE,
                    link:false,
                    width:30,
                    routePath:'',
                    isSort: true,
                    field_name: 'opportunity_type'
                },
                {
                    label: lang.LBL_OPPORTUNITY_FUNDER,
                    link:false,
                    width:50,
                    routePath:'',
                    isSort: true,
                    field_name: 'opportunity_funder'
                },
                {
                    label: lang.LBL_OPPORTUNITY_BY,
                    link:false,
                    width:50,
                    routePath:'',
                    isSort: true,
                    relRef:'opportunitys_users',
                    field_name: 'name'
                },
                {
                    label: lang.LBL_OPPORTUNITY_DEADLINE,
                    link:false,
                    width:30,
                    routePath:'',
                    isSort: true,
                    field_name: 'deadline'
                },
                {
                    label: lang.LBL_STAGE,
                    link:false,
                    width:30,
                    routePath:'',
                    isSort: true,
                    field_name: 'status'
                },
            ],
            columns: ['opportunity_title', 'opportunity_years', 'opportunity_type', 'opportunity_funder', 'created_by', 'deadline', 'status'],

        }
    },
    mounted() {
        this.childMethod();
    },
    methods:{
        childMethod(search=''){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.columns,search);
            }
        },
        openAction() {
            this.isActive = !this.isActive;
        }, 
    }
}

</script>



